import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function Page403() {
  return (
    <>
      <Helmet>
        <title>Unauthorized | NHIDirect</title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Unauthorized to view this page!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, you are not authorized to view this page. Please contact your administrator for more information.
          </Typography>

          <Box
            component="img"
            src="illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/" size="large" variant="contained" color="paleOrange" component={RouterLink}>
            <Typography>Go to Home</Typography>               
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
